module.exports = __webpack_public_path__ + "img/email.0b8f971e.png";